/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { useEffect, useState } from "react";

const Emakkece = () => {
  const [emakKece, setEmakKece] = useState([]);
  const [advisoryBoard, setAdvisoryBoard] = useState([]);

  useEffect(() => {
    fetchEmakKece();
    fetchAdvisoryBoard();
  }, []);

  const fetchEmakKece = async () => {
    try {
      const response = await fetch(
        "https://cms.okoce.net/api/admin/emak-keces"
      );
      if (!response.ok) {
        throw new Error("Gagal mengambil data emak kece");
      }
      const data = await response.json();
      setEmakKece(data.data[0] || []);
    } catch (error) {
      setEmakKece([]);
    }
  };

  useEffect(() => {
    fetchEmakKece();
  }, []);

  const fetchAdvisoryBoard = async () => {
    try {
      const response = await fetch(
        "https://cms.okoce.net/api/admin/advisory-boards"
      );
      if (!response.ok) {
        throw new Error("Gagal mengambil data dewan penasehat");
      }
      const data = await response.json();
      setAdvisoryBoard(data.data || []);
    } catch (error) {
      setAdvisoryBoard([]);
    }
  };
  return (
    <>
      <div className="px-20 py-20 bg-white max-md:px-5 mobile:mt-6 lg:mt-20">
        <div className="flex gap-5 max-md:flex-col max-md:gap-0">
          <div className="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
            <img
              className="mt-2.5 w-full aspect-[1.96] max-md:mt-10 max-md:max-w-full"
              src={`${process.env.REACT_APP_API_URL}/${emakKece.image}`}
              alt={emakKece.image}
            />
          </div>
          <div className="flex flex-col ml-5 w-6/12 max-md:ml-0 max-md:w-full">
            <div className="flex flex-col mt-2.5 font-bold text-black leading-[120%] max-md:mt-10 max-md:max-w-full">
              <div className="text-4xl max-md:max-w-full">{emakKece.title}</div>
              <div className="mt-6 text-lg leading-7 text-justify max-md:max-w-full">
                Emak Kece adalah program inovatif yang dirancang oleh OK OCE
                Indonesia, khusus untuk para ibu-ibu. Program ini dijalankan
                oleh para penggerak dan mitra OK OCE Indonesia, dengan tujuan
                memberdayakan serta meningkatkan keterampilan dan potensi
                ekonomi para ibu dalam berbagai bidang usaha.
                <br />
              </div>
              <a
                href={emakKece.url}
                className="justify-center items-center px-16 py-6 mt-10 text-2xl text-center text-white bg-[#e01f31] rounded-3xl max-md:px-5 max-md:max-w-full"
              >
                PELAJARI SELENGKAPNYA
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Responsive mobile diukuran 320px keatas*/}
      <div className="bg-white-300 w-full h-[20rem] grid justify-center content-center mobile:mt-72 mobile:mb-[55rem] lg:mt-20 lg:mb-20">
        <h1 className="font-extrabold text-4xl text-center">PELAKSANA</h1>
        <div className="flex justify-center">
          <div className="grid gap-4 mobile:grid-cols-1 lg:grid-cols-3">
            {" "}
            {/* Responsive mobile*/}
            {emakKece.implementer_logo?.map((logo, index) => (
              <div className="mt-4">
                <img
                  loading="lazy"
                  className="h-[15em]"
                  src={`${process.env.REACT_APP_API_URL}/${logo}`}
                  alt={`pelaksana ${index}`}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="bg-white-300 w-full h-[20rem] grid justify-center content-center mobile:mt-52 mobile:mb-[65rem] lg:mt-20 lg:mb-20">
        <h1 className="font-extrabold text-4xl text-center">PESERTA</h1>
        <div className="flex justify-center">
          <div className="grid gap-4 mobile:grid-cols-1 lg:grid-cols-5">
            {emakKece.participant_logo?.map((logo, index) => (
              <div className="mt-4">
                <img
                  loading="lazy"
                  className="h-[15em]"
                  src={`${process.env.REACT_APP_API_URL}/${logo}`}
                  alt={`peserta ${index}`}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="bg-white-300 w-full h-[20rem] grid justify-center content-center mobile:mt-52 mobile:mb-[55rem] lg:mt-20 lg:mb-20">
        <h1 className="font-extrabold py-5 text-4xl text-center">DURASI</h1>
        <div className="flex justify-center">
          <div className="grid gap-4 mobile:grid-cols-1 lg:grid-cols-4">
            {emakKece.duration_logo?.map((logo, index) => (
              <div className="mt-4">
                <img
                  loading="lazy"
                  className="h-[15em]"
                  src={`${process.env.REACT_APP_API_URL}/${logo}`}
                  alt={`durasi ${index}`}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="bg-white-300 w-full h-[20rem] grid justify-center content-center mobile:mt-52 mobile:mb-[30rem] lg:mt-10 lg:mb-10">
        <h1 className="font-extrabold py-5 text-4xl text-center">SUMBER DAYA</h1>
        <div className="flex justify-center">
          <div className="grid gap-4 mobile:grid-cols-1 lg:grid-cols-4">
            {emakKece.resource_logo?.map((logo, index) => (
              <div className="mt-4">
                <img
                  loading="lazy"
                  className="h-[15em]"
                  src={`${process.env.REACT_APP_API_URL}/${logo}`}
                  alt={`sumber daya ${index}`}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-[5rem] bg-white-300 w-full h-[50rem] grid justify-center content-center mobile:mb-[20rem] lg:mb-0">
        <h1 className="font-extrabold text-4xl text-center">TAHAPAN</h1>
        <div className="flex justify-center">
          <div className="grid grid-cols-1 gap-4">
            <div className="mt-1">
              <img
                className="h-[40em]"
                src={`${process.env.REACT_APP_API_URL}/${emakKece.stage_picture}`}
                alt={`tahapan ${emakKece.stage_picture}`}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white-300 w-full h-[20rem] grid justify-center content-center mobile:mt-52 mobile:mb-[45rem] lg:mt-10 lg:mb-5">
        <h1 className="font-extrabold py-5 text-4xl text-center">MATERI</h1>
        <div className="flex justify-center">
          <div className="grid gap-4 mobile:grid-cols-1 lg:grid-cols-4">
            {emakKece.material_logo?.map((logo, index) => (
              <div className="mt-4">
                <img
                  loading="lazy"
                  className="h-[15em]"
                  src={`${process.env.REACT_APP_API_URL}/${logo}`}
                  alt={`materi ${index}`}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="bg-white-300 w-full h-[40rem] grid justify-center content-center mobile:mb-[20rem] lg:mb-5">
        <h1 className="font-extrabold py-5 text-4xl text-center">
          DEWAN PENASEHAT
        </h1>
        <div className="flex justify-center">
          <div className="grid gap-4 mobile:grid-cols-1 lg:grid-cols-3">
            {advisoryBoard?.map((board, index) => (
              <div className="mt-4" key={board.id}>
                <img
                  className="h-[15em] mb-4 m-4"
                  src={`${process.env.REACT_APP_API_URL}/${board.image}`}
                  alt={`dewan penasehat ${index}`}
                />
                <p className="text-center">{board.name}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Emakkece;
